const listeners = new Set();
let notice = null;

export function isSessionRefreshDetail(detail) {
  if (typeof detail !== "string") return false;
  return (
    detail.includes("session needs to be refreshed") ||
    detail.includes("Re-authentication required") ||
    detail.includes("re-authenticate") ||
    detail.includes("missing claims")
  );
}

export function getSessionRefreshNotice() {
  return notice;
}

export function subscribeSessionRefreshNotice(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit() {
  listeners.forEach((listener) => listener(notice));
}

export function showSessionRefreshNotice(detail) {
  if (notice) return;
  notice = {
    detail:
      typeof detail === "string" && detail
        ? detail
        : "Your session needs to be refreshed. Please sign in again.",
  };
  emit();
}

export function clearSessionRefreshNotice() {
  if (!notice) return;
  notice = null;
  emit();
}
